import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { Booth, CategoryFilterValues } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { trackEvent } from '../../../../../services/services';
import Slot from '../Slot';
import BoothEdit from './BoothEdit';
import BoothPreview from './BoothPreview';

interface BoothModalProps {
  booth: Booth;
  filters?: any;
  customBackgroundColor?: string;
}

const BoothModal = ({ booth, filters, customBackgroundColor }: BoothModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filterValues, setFilterValues] = useState<CategoryFilterValues[]>([]);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const signupModalVisible = useSelector((state) => state.vbw.signupModalVisible);
  const event = useSelector((state) => state.common.event);

  useEffect(() => {
    // We only consider the first filter as this template should only work with one filter
    filters && filters.length > 0 && setFilterValues(filters[0].categoryFilterValues);
  }, [filters]);

  useEffect(() => {
    if (isOpen) trackEvent('BOOTH_OPEN', { boothid: booth._id }, event?._id);
  }, [isOpen, event]);

  return (
    <div>
      <Popup
        key={booth._id}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        lockScroll
        nested
        closeOnEscape={false}
        closeOnDocumentClick={!viewerOpen && !signupModalVisible}
        contentStyle={{ width: '80%', maxWidth: '1300px' }}
        trigger={
          <button type="button" className="focus:outline-none" style={{ width: '100%' }}>
            <Slot
              heading={
                (booth.categoryFilterValues?.length > 0 && filterValues && filterValues.find((el) => el._id === booth.categoryFilterValues[0])?.value) ||
                booth.name
              }
              description={booth.slogan ?? ''}
              logo={booth.logo ?? ''}
              customBackgroundColor={customBackgroundColor}
            />
          </button>
        }
        position="center center"
        modal>
        {isEditMode ? (
          <BoothEdit
            booth={booth}
            filters={filters}
            isEditMode={isEditMode}
            setIsOpen={setIsOpen}
            setViewerOpen={setViewerOpen}
            setIsEditMode={setIsEditMode}
          />
        ) : (
          <BoothPreview
            booth={booth}
            filters={filters}
            isEditMode={isEditMode}
            setIsOpen={setIsOpen}
            setViewerOpen={setViewerOpen}
            setIsEditMode={setIsEditMode}
          />
        )}
      </Popup>
    </div>
  );
};

export default BoothModal;
